import React, {useState, useContext} from 'react';
import styled from 'styled-components';
import {OverlayContext} from '../contexts/OverlayContext';

import {OzButton, OzCard, OzSelect, OzCol, OzRow} from '@ozwol/webui';

import WebhooksService from '../services/WebhooksService';

import CardHeaderTitle from '../components/CardHeaderTitle';

import ErrorMessage from '../components/ErrorMessage';

import {formatError, changeDate, toUtc} from './../helpers';

const Container = styled.div`
  width: 450px;
`;


const ModalRollWebhook = ({item, onSuccess}) => {
  const {removeOverlay} = useContext(OverlayContext);
	const [errorMessage, setErrorMessage] = useState(false);
	const [time, setTime] = useState(null);

  return (
    <Container>

      <OzCard
        headerLeft={
          <CardHeaderTitle 
            title={"Roll HMAC"} 
          />
        }
        headerSeparator={true}
        footerLeft={<OzButton variant={"chetwodeblue-o"} onClick={() => removeOverlay("webhook")}>Cancel</OzButton>}
        footerRight={<OzButton variant={"silvertree"} onClick={() => 
					WebhooksService.rollHMAC(item.uuid, {expiryDatetime: toUtc(changeDate(new Date(), time, "hours"))}).then((response) => {
						onSuccess();
					}).catch((error) => {
						setErrorMessage(formatError(error));
					})
				}>Roll</OzButton>}
      >
        Create new authentication code.

        <br/>
				<OzRow>
					<OzCol widthmd="12">
						<OzSelect 
							label="Time"
							selected={time}
							maxHeight={"400px"}
							width={"100%"}
							values={[
								{
									"name": "Now",
									"value": null
								},{
									"name": "+1h",
									"value": 1
								},{
									"name": "+2h",
									"value": 2
								},{
									"name": "+4h",
									"value": 4
								},{
									"name": "+8h",
									"value": 8
								},{
									"name": "+12h",
									"value": 12
								},{
									"name": "+24h",
									"value": 24
								}
							]}
							onChange={(val) => setTime(val)}
						/>
					</OzCol>
				</OzRow>
				
				<ErrorMessage>
					{errorMessage}
				</ErrorMessage>
			

      </OzCard>

    </Container>
  );

}

export default ModalRollWebhook;
